import { render, staticRenderFns } from "./fanatic_codes.vue?vue&type=template&id=0fec68b0&"
import script from "./fanatic_codes.vue?vue&type=script&lang=js&"
export * from "./fanatic_codes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports